import styled from 'styled-components';

export const Filters = styled.div`&&&{
  background: #f7f7f7f7;
  padding: 28px;
  border: solid 1px #ccc;
  border-top: none;
  
  &.closed {
    height: 0;
    padding: 0;
    border: none;
    overflow: hidden;
  }
  
}`;

export const GraphControl = styled.div`&&&{
  display: flex;
  margin-top: 7px;
  
  > * {
    min-width: 200px;
    max-width: 300px;
    
    &:not(:first-child) {
      margin-left: 28px;
    }
  }
  
  .react-datepicker__day {
    width: 2.0rem;
    height: 2.0rem;
    line-height: 2.0rem;
    border-radius: 0;
    margin: 0;
    border: solid 1px transparent;
    
    &:hover {
      border-radius: 0;
    }
    
  }
  
  .react-datepicker__day--in-range {
    background: ${props => props.theme.primaryXXLight};
    color: #000;
    border-color: #fff;
    
    &:hover {
      background: ${props => props.theme.primaryXLight};
    }
    
  }
  
  .react-datepicker__day--selected {
    background: ${props => props.theme.primary};
    color: #fff;
    
    &:hover {
      background: ${props => props.theme.primaryDark};
    }
    
  }
  
  .Select, .dropdown {
    margin-bottom: 14px;
  }
  
  .Select-menu-outer {
    z-index: 2;
  }
  
}`;

export const DatepickerLabel = styled.div`&&&{
  text-align: center;
}`;

export const Accordion = styled.div`&&&{
  text-align: center;
  padding: 14px;
  background: #eee;
  border: solid 1px #ccc;
  border-top: none;
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  user-select: none;
  
  &:hover {
    background: #e7e7e7;
  }
  
}`;





// WEBPACK FOOTER //
// ./src/pages/Observations/components/ObservationFilters/style.js